import classNames from 'classnames';
import React, {forwardRef, InputHTMLAttributes, ReactNode} from 'react';

// Classes here borrowed from weave's input component. Can't use the input
// component directly because it doesn't forward refs or a few other important
// props like `name`.
const INPUT_CONTAINER_CLASSES = classNames(
  'flex flex-row items-center gap-4 grow shrink',
  'px-8 py-4',
  'bg-white dark:bg-moon-900',
  'text-moon-800 dark:text-moon-200',
  'rounded-sm outline outline-1 outline-moon-250 dark:outline-moon-700',
  'night-aware'
);

const INPUT_CLASSES = classNames(
  'flex-1 bg-inherit',
  'leading-8 h-24',
  'appearance-none border-none',
  'focus:outline-none',
  'placeholder-moon-500',
  'dark:selection:bg-moon-650 dark:selection:text-moon-200'
);

type InlineComboboxInputProps = {
  /**
   * Allow something to be inserted before the input box. Probably an icon or
   * something.
   */
  beforeInput?: ReactNode;
} & InputHTMLAttributes<HTMLInputElement>;

export const InlineComboboxInput = forwardRef<
  HTMLInputElement,
  InlineComboboxInputProps
>(function InlineComboboxInput({beforeInput, capture, ...props}, forwardedRef) {
  return (
    <div className={INPUT_CONTAINER_CLASSES}>
      {beforeInput}
      <input {...(props as any)} ref={forwardedRef} className={INPUT_CLASSES} />
    </div>
  );
});
